<template>
  <div class="register-step">
    <div class="step-header">
      <h2>选择工作区域</h2>
    </div>
    
    <div class="location-info" v-if="location.address">
      <i class="el-icon-location"></i>
      <span>{{ location.address }}</span>
      <button class="relocate-btn" @click="$emit('relocate')">重新定位</button>
    </div>
    <div class="location-info loading" v-else-if="location.loading">
      <span>正在获取位置...</span>
    </div>
    <div class="location-info error" v-else-if="location.error">
      <span>{{ location.error }}</span>
      <button class="relocate-btn" @click="$emit('relocate')">重试</button>
    </div>
    
    <div class="form-group">
      <label>机构名称</label>
      <select :value="organizationId" @change="$emit('update:organizationId', $event.target.value)">
        <option value="">请选择机构名称</option>
        <option v-for="org in organizationList" :key="org.id" :value="org.id">
          {{ org.name }}{{ org.city ? ` (${org.city})` : '' }}
        </option>
      </select>
    </div>
    
    <div class="form-group">
      <label>工作场站</label>
      <select :value="stationId" @change="handleStationChange">
        <option value="">请选择工作场站</option>
        <option v-for="station in stationList" :key="station.id" :value="station.id">
          [{{ station.type }}] {{ station.name }}
        </option>
      </select>
      <div class="station-types" v-if="stationList.length > 0">
        <span class="type-tag"><i class="el-icon-plane"></i> 机场</span>
        <span class="type-tag"><i class="el-icon-truck"></i> 高铁站</span>
        <span class="type-tag"><i class="el-icon-place"></i> 景区</span>
        <span class="type-tag"><i class="el-icon-goods"></i> 商圈</span>
      </div>
    </div>
    
    <div class="btn-area">
      <button class="prev-btn" @click="$emit('prev')">
        <span>←</span>
        <span>上一步</span>
      </button>
      <button 
        class="submit-btn"
        :disabled="!canSubmit || submitLoading"
        @click="$emit('submit')"
      >
        <span v-if="submitLoading" class="loading-spinner"></span>
        <span>{{ submitLoading ? '提交中...' : '提交注册' }}</span>
        <i v-if="!submitLoading" class="el-icon-check btn-icon"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectAreaStep',
  props: {
    location: { type: Object, default: () => ({ loading: false, error: '', address: '' }) },
    organizationId: { type: [String, Number], default: '' },
    stationId: { type: [String, Number], default: '' },
    organizationList: { type: Array, default: () => [] },
    stationList: { type: Array, default: () => [] },
    submitLoading: { type: Boolean, default: false }
  },
  computed: {
    canSubmit() {
      return this.organizationId && this.stationId
    }
  },
  methods: {
    handleStationChange(e) {
      const stationId = e.target.value
      this.$emit('update:stationId', stationId)
      const station = this.stationList.find(s => s.id === stationId || s.id === Number(stationId))
      if (station) {
        this.$emit('station-change', station.name)
      }
    },
    getStationTypeLabel(type) {
      return type || '其他'
    }
  }
}
</script>

<style scoped>
.register-step {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 20px 16px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  animation: slideUp 0.5s ease-out;
  position: relative;
  overflow: hidden;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.step-header {
  text-align: center;
  margin-bottom: 16px;
}

.step-header h2 {
  font-size: 24px;
  color: #1a1a2e;
  margin: 0 0 8px;
  font-weight: 700;
}

.step-header .subtitle {
  font-size: 14px;
  color: #8e8e93;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #1a1a2e;
  margin-bottom: 10px;
  font-weight: 600;
}

.form-group select {
  width: 100%;
  height: 52px;
  border: 2px solid #e8e8ed;
  border-radius: 14px;
  padding: 0 16px;
  font-size: 16px;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%232B77FF' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px 8px;
  padding-right: 40px;
  touch-action: manipulation;
  outline: none;
  transition: all 0.3s ease;
}

.form-group select:focus {
  border-color: #2B77FF;
  box-shadow: 0 0 0 4px rgba(43, 119, 255, 0.1);
}

.station-types {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.type-tag {
  font-size: 11px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 10px;
}

.location-info {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  padding: 12px 14px;
  border-radius: 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  border: 1px solid #e8e8ed;
}

.location-info.error {
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  color: #e74c3c;
  border-color: rgba(231, 76, 60, 0.2);
}

.relocate-btn {
  margin-left: auto;
  padding: 8px 16px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  min-height: 36px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(43, 119, 255, 0.25);
}

.relocate-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 8px rgba(43, 119, 255, 0.25);
}

.btn-area {
  display: flex;
  gap: 12px;
  margin-top: 28px;
}

.submit-btn {
  flex: 1;
  height: 54px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 27px;
  font-size: 17px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  font-weight: 600;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 8px 25px rgba(43, 119, 255, 0.35);
}

.submit-btn:active {
  transform: scale(0.97);
  box-shadow: 0 4px 15px rgba(43, 119, 255, 0.35);
}

.submit-btn:disabled {
  background: linear-gradient(135deg, #d0d0d0 0%, #b0b0b0 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-icon {
  font-size: 16px;
}

.loading-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.prev-btn {
  min-width: 100px;
  height: 54px;
  background: rgba(255, 255, 255, 0.9);
  color: #666;
  border: 2px solid #e0e0e0;
  border-radius: 27px;
  font-size: 15px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 500;
}

.prev-btn:active {
  background: #f5f5f5;
  transform: scale(0.97);
}

@media screen and (max-width: 480px) {
  .register-step {
    padding: 20px 16px;
    border-radius: 20px;
  }

  .header-icon {
    font-size: 40px;
  }

  .step-header h2 {
    font-size: 20px;
  }

  .prev-btn {
    min-width: 90px;
  }
}

@media screen and (max-width: 360px) {
  .register-step {
    padding: 16px 12px;
  }

  .step-header h2 {
    font-size: 18px;
  }

  .btn-area {
    gap: 8px;
  }
  
  .prev-btn {
    min-width: 80px;
  }
}
</style>
